// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Comercial_LeadTimesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/comercial/lead_times.
 *
 * Mean lead time in days between funnel stages, restricted to entities whose
 * trailing event falls inside the user's date filter window. Each metric
 * derives from a DATEDIFF over rows where both stage timestamps are
 * available:
 *
 *   - mean_dias_orcado_aprovado    — DATEDIFF(orcamento_data_first_approved,
 *                                              orcamento_data)
 *     NB: there is no orcamento approval timestamp column in the schema
 *     today, so this stage uses orcamento_data → compromisso first-creation
 *     date as a stand-in (compromisso_data_cadastro). Plan §5 documents this
 *     as the closest proxy until a dedicated column is added.
 *
 *   - mean_dias_aprovado_realizado — DATEDIFF(compromisso_data_hora_inicio,
 *                                              compromisso_data_cadastro)
 *     For compromissos with status Realizado.
 *
 *   - mean_dias_realizado_recebido — DATEDIFF(recebimento_data,
 *                                              compromisso_data_hora_inicio)
 *     Joined via recebimento_origem='compromisso' AND
 *     recebimento_origem_id=compromisso_id.
 *
 * Sample sizes are surfaced so callers can disambiguate a 0-day mean from a
 * "no data" 0.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Comercial_LeadTimesResponseDados {
mean_dias_orcado_aprovado: number
sample_orcado_aprovado: number
mean_dias_aprovado_realizado: number
sample_aprovado_realizado: number
mean_dias_realizado_recebido: number
sample_realizado_recebido: number
}

export type Comercial_LeadTimesResponse = ApiResponse<Comercial_LeadTimesResponseDados>;

registerResponseContract('Comercial_LeadTimesResponse', {
  mean_dias_orcado_aprovado:    { type: 'number',  required: true },
  sample_orcado_aprovado:       { type: 'number',  required: true },
  mean_dias_aprovado_realizado: { type: 'number',  required: true },
  sample_aprovado_realizado:    { type: 'number',  required: true },
  mean_dias_realizado_recebido: { type: 'number',  required: true },
  sample_realizado_recebido:    { type: 'number',  required: true },
})
